import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getUser = createAsyncThunk(
  "user/get",
  async ({ start, count, search }, thunkAPI) => {
    let formData = new FormData();
    // Dulu ditulis formData.append(start, "") — nilainya dipakai sebagai NAMA field,
    // jadi backend selalu menerima start/count/search kosong. Kosong = tanpa
    // LIMIT/OFFSET (ParamNull → nil), yang memang dipakai halaman /setup-user
    // karena filter, pencarian, dan paginasinya client-side.
    formData.append("start", start ?? "");
    formData.append("count", count ?? "");
    formData.append("search", search ?? "");

    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getUser",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const userMin = createAsyncThunk(
  "userSelector/get",
  async (thunkAPI) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "minNotUseUser",
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const userMinAll = createAsyncThunk(
  "userSelector/get",
  async (thunkAPI) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "minAllUser",
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertUser = createAsyncThunk(
  "user/insert",
  async ({ Username, Nik }, thunkAPI) => {
    let formData = new FormData();

    formData.append("Username", Username);
    formData.append("Nik", Nik);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertUser",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateUser = createAsyncThunk(
  "user/insert",
  async ({ NamaUser, UserID, status }, thunkAPI) => {
    let formData = new FormData();

    formData.append("NamaUser", NamaUser);
    formData.append("UserID", UserID);
    formData.append("Status", status);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateUser",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

const initialState = {
  message: "",
  approveList: [],
  minData: [],
  minDataAll: [],
  data: [],
  isApproveListFetching: false,
  isApproveListSuccess: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isOtoritasUpdateFetching: false,
  isOtoritasUpdateSuccess: false,
  isOtoritasUpdateError: false,
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  isMinAllFetching: false,
  isMinAllSuccess: false,
  isMinAllError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

export const useradminSlice = createSlice({
  name: "userAdmins",
  initialState,
  reducers: {},
  extraReducers: {
    [getUser.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getUser.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload.message;
    },
    [getUser.pending]: (state) => {
      state.isGetFetching = true;
    },

    [userMin.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minData = payload.data;
      return state;
    },
    [userMin.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload.message;
    },
    [userMin.pending]: (state) => {
      state.isMinFetching = true;
    },

    //GETALL
    [userMinAll.fulfilled]: (state, { payload }) => {
      state.isMinAllFetching = false;
      state.isMinAllSuccess = true;
      state.minDataAll = payload.data;
      return state;
    },
    [userMinAll.rejected]: (state, { payload }) => {
      state.isMinAllFetching = false;
      state.isMinAllError = true;
      state.errorMessage = payload.message;
    },
    [userMinAll.pending]: (state) => {
      state.isMinAllFetching = true;
    },

    // INSERT
    [insertUser.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [insertUser.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload.message;
    },
    [insertUser.pending]: (state) => {
      state.isInsertFetching = true;
    },
    // UPDATE
    [updateUser.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [updateUser.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [updateUser.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const userAdminSlice = (state) => state.userAdmins;
